import React from 'react';

export const ConfidenceMeter = ({ value = 0 }) => {
  const getColor = (v) => {
    if (v >= 80) return 'bg-emerald-400';
    if (v >= 60) return 'bg-[hsl(var(--primary))]';
    if (v >= 40) return 'bg-yellow-500';
    return 'bg-red-400';
  };

  const getLabel = (v) => {
    if (v >= 80) return 'Very High';
    if (v >= 60) return 'High';
    if (v >= 40) return 'Moderate';
    return 'Low';
  };

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-xs font-medium text-[hsl(var(--muted-foreground))]">Confidence</span>
        <span className="font-mono text-sm font-semibold tabular-nums text-[hsl(var(--primary))]">
          {value}%
          <span className="text-[10px] ml-1 text-[hsl(var(--muted-foreground))] font-normal">
            {getLabel(value)}
          </span>
        </span>
      </div>
      <div className="h-2 rounded-full bg-[hsl(var(--surface-2))] overflow-hidden">
        <div
          className={`h-full rounded-full confidence-fill ${getColor(value)}`}
          style={{ width: `${Math.min(value, 100)}%` }}
        />
      </div>
    </div>
  );
};
